export default __webpack_public_path__ + "static/media/kheng-music2.4caefff8.jpg";